type QuantitySettings = {
  type?: string;
  values?: Array<number | string>;
  minimum?: number;
  maximum?: number;
  min?: number;
  max?: number;
};

/** Restore an existing order quantity without resetting a valid choice to the catalogue default. */
export function resolveInitialQuantity(
  initialQuantity: number | undefined,
  hasCopiesOption: boolean,
  settings?: QuantitySettings,
): number {
  if (hasCopiesOption) return 1;
  const requested = Number.isInteger(initialQuantity) && Number(initialQuantity) > 0
    ? Number(initialQuantity)
    : undefined;
  const fixed = settings?.type === 'fixed'
    ? (settings.values || []).map(Number).filter((value) => Number.isInteger(value) && value > 0)
    : [];
  if (fixed.length) return requested && fixed.includes(requested) ? requested : fixed[0];
  const minimum = Math.max(1, Math.ceil(Number(settings?.minimum) || 1));
  const maximum = Math.max(minimum, Math.floor(Number(settings?.maximum) || Number.MAX_SAFE_INTEGER));
  return Math.min(maximum, Math.max(minimum, requested || minimum));
}

/** Copies are physical units inside one order, not additional sets. Presets
 * under an open/minimum policy are suggestions, never an exclusive list. */
export function resolveInitialCopies(current: unknown, settings: QuantitySettings): number {
  return resolveInitialQuantity(Number(current), false, {
    ...settings,
    minimum: settings.minimum ?? settings.min,
    maximum: settings.maximum ?? settings.max ?? 100000,
  });
}

/** Explicit supplier limits take precedence over extrapolated preset buttons. */
export function resolveMatrixQuantityMaximum(
  policyMaximum: unknown,
  settingsMaximum: unknown,
  optionMaximum: unknown,
  presets: number[],
): number {
  for (const candidate of [policyMaximum, settingsMaximum, optionMaximum]) {
    const value = Number(candidate);
    if (Number.isFinite(value) && value >= 1) return Math.floor(value);
  }
  const validPresets = presets.filter((value) => Number.isFinite(value) && value > 0);
  return validPresets.length ? Math.max(...validPresets) * 10 : 100000;
}
